import { AsyncSubject, Observable } from 'common/barrels/rx';
import { Request } from 'common/request';
import { RequestWrapper, Event } from 'common/event';
import { AccessDenied } from 'common/exceptions/accessdenied';
import { SystemError } from 'common/exceptions/systemerror';
import { Serializer } from 'common/serializer';
import * as alerts from 'common/dom/alerts';

let accessDeniedMessage = 'Please check you are logged in and have permission to perform the requested action';
let accessDeniedTitle = 'Access Denied';
let systemErrorMessage = 'Please check you are logged in and have permission to perform the requested action';
let systemErrorTitle = 'System Error';

export function standardRequest<TEvent extends Event, TResponse>(serializer: Serializer, x: RequestWrapper<TEvent, TResponse>, path: string): Request {
    return Request
        .create(serializer, path)
        .handle(AccessDenied, r => alerts.error(accessDeniedMessage, accessDeniedTitle))
        .handle(SystemError, r => alerts.error(systemErrorMessage, systemErrorTitle, true))
        .unknown(r => x.error(r))
        .error((r, t, e) => x.error(new Error(e)))
        ;
}

export function setAccessDeniedText(message: string, title: string) {
    accessDeniedMessage = message;
    accessDeniedTitle = title;
}

export function setSystemErrorText(message: string, title: string) {
    systemErrorMessage = message;
    systemErrorTitle = title;
}

export function getRequest<T, T2>(serializer: Serializer, url: string, type: { new(...args: any[]): T }, transform: (t: T) => T2): Observable<T2> {
    const s = new AsyncSubject<T2>();

    new Request(serializer, url)
        .handle(type, x => { s.next(transform(x)); s.complete(); })
        .handle(AccessDenied, _ => alerts.error(accessDeniedMessage, accessDeniedTitle, true))
        .handle(SystemError, _ => alerts.error(systemErrorMessage, systemErrorTitle, true))
        .unknown(() => s.error({}))
        .error((xhr, status, error) => s.error({ xhr: xhr, status: status, error: error }))
        .get();

    return s;
}